import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ac62c84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "category-boxes pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CategoryBoxComponent = _resolveComponent("CategoryBoxComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CategoryBoxComponent, {
      obj: {
			name: 'mods',
			params: { 
				game: 'assetto-corsa'
			},
      query: {
        page: 1
      }
		},
      image: "aclogo"
    }),
    _createVNode(_component_CategoryBoxComponent, {
      obj: {
			name: 'mods',
			params: {
				game: 'beamng-drive'
			},
			query: {
        page: 1
      }
		},
      image: "beamnglogo"
    })
  ]))
}